import React from "react";
import { useNavigate } from "react-router-dom";
import images from '../../constants/images';

const SubscriptionExpiredPage = () => {
  const navigate = useNavigate();

  const handleContactSupport = () => {
    alert("Please contact support to renew your subscription.");
  };

  const handleGoBack = () => {
    navigate("/onboarding");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F0FD] text-black px-4 sm:px-6 md:px-8 py-4">
      <div className="group hover:border-2 hover:border-[#C0ACF3] transition-all duration-100 max-w-[500px] bg-white p-6 sm:p-8 md:p-10 rounded-2xl shadow-xl border border-[#C0ACF3]">
        <div className="text-center mb-6">
          <div className="font-semibold flex items-center justify-center gap-2">
            <img src={images.stackguard} alt="Logo" className="h-8 w-8" />
            <span className="text-[24px] font-[400] font-inter text-black">
              StackGuard
            </span>
          </div>
        </div>
        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        </div>
        <div className="text-center mb-8">
          <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 md:mb-4">
            Subscription Expired
          </h1>
          <p className="text-gray-600 mb-4">
            Your StackGuard subscription has expired. Please renew your subscription to continue using our services.
          </p>
          <p className="text-sm text-gray-500">
            If you believe this is an error, please contact our support team.
          </p>
        </div>
        <div className="space-y-3">
          <button
            onClick={handleContactSupport}
            className="w-full bg-[#C0ACF3] hover:bg-[#A890E8] text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200">
            Contact Support
          </button>
          
          <button
            onClick={handleGoBack}
            className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-4 rounded-lg transition-all duration-200">
            Go Back
          </button>
        </div>
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            Need immediate assistance? Call us at +1-800-STACKGUARD
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpiredPage;